import React from "react";
import { Container, Card, Col } from "react-bootstrap";
import "../../../../App.css";
import { ENTITY_LABELS } from "../../../../utils/labelMapping";

function MOverviewComponent({ checkedItems, handleCheckBoxChange, isBrand }) {
  return (
    <Container className="mb-3">
      <Card as={Col} md="12" className="border-0 whi">
        <Card.Body>
          <Card.Title className="">
            {" "}
            {`${isBrand ? ENTITY_LABELS.brand : ENTITY_LABELS.product}`} Overview and Favorability
          </Card.Title>
          <Card.Text className="mt-4">
            What dimensions do you want to focus on (choose all that apply)
          </Card.Text>
          <ul className="focus-on">
            {[
              `${isBrand ? "Brand" : "Product"} Description`,
              "Top 5 Positive Attributes",
              "Top 5 Negative Attributes",
              // "Top 5 Positive Statements",
              // "Top 5 Negative Statements",
            ].map((key,index) => (
              <li key={key}>
                <input
                  type="checkbox"
                  name=""
                  value=""
                  disabled={index === 0}
                  checked={checkedItems.includes(key)}
                  onChange={() =>
                    handleCheckBoxChange("Brand Representation", key)
                  }
                />{" "}
                {key}
              </li>
            ))}
          </ul>
          <small></small>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default MOverviewComponent;
